import {createReducer} from '@reduxjs/toolkit';
import {
    clearRanges,
} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/actions';
import {getIpRangesSuccess} from 'src/openapi/admin/apis/IpControllerApi';


import type {IpRangeSection} from 'src/openapi/admin/models/IpRangeSection';

export type State = {
    [accountId: number]: IpRangeSection,
};

const defaultState: State = {};

export const ranges = createReducer(defaultState, builder => builder
    .addCase(getIpRangesSuccess, (state, action) => {
        return {
            ...state,
            [action.payload.meta.accountId]: action.payload.data,
        };
    }).addCase(clearRanges, () => ({})),
);
